export enum IneligibilityType {
	TpoUser = "TpoUser",
	NoSolarProducts = "NoSolarProducts",
	General = "General",
}
